/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function SustainabilityPractices() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { sustainabilityPracticesComment, policyOfSustainability } = countryBrandApplication;

	useEffect(() => {
		policyOfSustainability === "SI"
			? setPreviousStep(currentStep - 1)
			: setPreviousStep(currentStep - 2);
		const submitStepData = () => {
			const sustainabilityPracticesComment = formRef.current.elements.comment?.value;

			update({
				data: {
					sustainabilityPracticesComment,
				},
				nextStep: currentStep + 1,
			});
		};
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-13">
			<section>
				<h3>14 - Iniciativas y/o prácticas de sostenibilidad destacadas</h3>
				<label htmlFor="comment">
					<p>
						Describa a continuación las iniciativas, proyectos, programas o prácticas implementadas
						o en implementación actualmente en el ámbito de su organización en caso de aplicar.
					</p>
					<textarea rows="5" name="comment" defaultValue={sustainabilityPracticesComment} />
				</label>
			</section>
		</div>
	);
}

export { SustainabilityPractices };
